import React, { useState, useRef, useEffect } from 'react';
import { Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import Textarea from '@/components/ui/Textarea';
import { useGetComment } from './hooks/useGetComment';
import { useUpdateComment } from './hooks/useUpdateComment';
import { Resolution886ResultEnum } from '@/enums/Resolution886';
import * as S from './styles';

export function Comment({ result_type }: { result_type: Resolution886ResultEnum }): JSX.Element {
	const [localComment, setLocalComment] = useState<string>('');

	const { comment } = useGetComment();
	const { updateComment } = useUpdateComment();
	const timerRef = useRef<NodeJS.Timeout | null>(null);

	useEffect(() => {
		if (comment !== undefined) {
			setLocalComment(comment || '');
		}
	}, [comment]);

	function handleOnChange(e: React.ChangeEvent<HTMLTextAreaElement>): void {
		const { value } = e.target;
		setLocalComment(value);

		clearTimeout(timerRef.current!);

		timerRef.current = setTimeout(() => {
			updateComment({ comment: value, result_type });
		}, 1000);
	}

	return (
		<Col lg={24}>
			<S.HeadingSmall>{I18n.get('Observations')}</S.HeadingSmall>
			<Textarea
				showCount
				maxLength={500}
				value={localComment}
				onChange={handleOnChange}
				placeholder={I18n.get('Observations')}
				autoSize={{ minRows: 2, maxRows: 10 }}
			/>
		</Col>
	);
}
